import { fetch } from 'utils/api';

export function api_fetchRegulations() {
  return fetch({
    url: `/regulations`,
    method: 'GET',
    dataType: 'Regulations'
  });
}
